import * as React from 'react';
import * as moment from 'moment';

import { renderEmpty } from '../../common/Render';
import { formatDate } from '../../util/StringUtil';
import { sortByKeyComparator } from '../../util/ArrayUtil';
import translate from '../../../../locale/translate';

import { IReportSettings, MAV } from '../../../../interfaces';

import EventTable from '../eventCommon/EventTable';
import ISettings from '../eventCommon/ISettings';
import IWidgetProps from './IWidgetProps';

interface IEventsById {
    nodeId?: MAV.IEvent[];
}

interface IEventsByDay {
    timestamp?: MAV.IEvent[];
}

interface IProps extends IWidgetProps {
    settings: ISettings;
}

export default class Widget extends React.Component<IProps, {}> {
    static propTypes = {
        events: React.PropTypes.object.isRequired,
        systems: React.PropTypes.array.isRequired,
        settings: React.PropTypes.object.isRequired,
        reportSettings: React.PropTypes.object.isRequired,
    };

    renderVirusInformation(information: { Count: number, Checked: number }) {
        if (!information) {
            return translate.gettext('No MAV installed');
        }

        return information.Count;
    }

    renderSystem(system: MAV.ISystem) {
        return (
            <tr key={system.id}>
                <td>{system.name}</td>
                <td className="text-right">{this.renderVirusInformation(system.virusInformation)}</td>
            </tr>
        );
    }

    renderSummaryTable(systems: MAV.ISystem[], settings: ISettings, reportSettings: IReportSettings) {
        return (
            <div className="space-xl" key="summary">
                <table className="table">
                    <thead>
                        <tr>
                            <th className="col-xs-6">{translate.gettext('Name')}</th>
                            <th className="col-xs-6 text-right">{translate.gettext('MAV thread count')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {systems.map(this.renderSystem.bind(this))}
                    </tbody>
                </table >
            </div >
        );
    }

    renderEventTables(eventsByDay: IEventsByDay, settings: ISettings, reportSettings: IReportSettings) {
        const keys = Object.keys(eventsByDay).sort();

        return keys.map((timestamp: string) => {
            const nodeKey = `node-${timestamp}`;
            const events = eventsByDay[timestamp].sort(sortByKeyComparator('Timestamp', -1));

            return (
                <div key={nodeKey}>
                    <EventTable title={formatDate(parseInt(timestamp), 'LL')} events={events} settings={settings} />
                </div>
            );
        });
    }

    renderData(eventsByDay: IEventsByDay, settings: ISettings, reportSettings: IReportSettings) {
        return this.renderEventTables(eventsByDay, settings, reportSettings)
    }

    prepareData(systems: MAV.ISystem[], events: IEventsById): IEventsByDay {
        return systems.reduce((r, system: MAV.ISystem) => {
            const sEvents = events[system.id] || [];

            sEvents.forEach((event: MAV.IEvent) => {
                const dateId = moment(event.Timestamp).startOf('day').valueOf();
                event.SystemName = system.name;

                const dayEvents = r[dateId] || (r[dateId] = []);
                dayEvents.push(event);
            });

            return r;
        }, {});
    }

    render() {
        let { systems } = this.props;
        const { events, settings, reportSettings } = this.props;
        const eventsByDay = this.prepareData(systems, events);

        systems = systems.filter((system: MAV.ISystem) => {
            if (!system.virusInformation) {
                return false;
            }

            return true;
        });

        let renderedData;
        if (systems && systems.length && Object.keys(eventsByDay).length) {
            renderedData = this.renderData(eventsByDay, settings, reportSettings);
        } else if (systems.length) {
            renderedData = renderEmpty(translate.gettext("No threads occured"), translate.gettext("No threads where detected by the scanner and guard"));
        }  else {
            renderedData = renderEmpty(translate.gettext("No managed antivirus"), translate.gettext("None of the selected systems uses managed antivirus"));
        }

        return (
            <div>
                {renderedData}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/mav/listEventDays/Widget.tsx